__turbopack_context__.v({
  "card": "BlockImageNavTile-module-scss-module__QMOJXW__card",
  "content": "BlockImageNavTile-module-scss-module__QMOJXW__content",
  "cta": "BlockImageNavTile-module-scss-module__QMOJXW__cta",
  "flushBottom": "BlockImageNavTile-module-scss-module__QMOJXW__flushBottom",
  "flushTop": "BlockImageNavTile-module-scss-module__QMOJXW__flushTop",
  "image": "BlockImageNavTile-module-scss-module__QMOJXW__image",
  "inner": "BlockImageNavTile-module-scss-module__QMOJXW__inner",
  "root": "BlockImageNavTile-module-scss-module__QMOJXW__root",
  "title": "BlockImageNavTile-module-scss-module__QMOJXW__title",
});
